import {
	reOrgNotificationConstants
}from "./constants"

const initialState = {
	error     : null,
	isSending : false,
	changed   : null,
	paged     : {},
	isAny     : false
}

export default function (state = initialState, action){
	switch (action.type){
		case (reOrgNotificationConstants.GetPaged.REQUEST):
		case (reOrgNotificationConstants.GetPagedAll.REQUEST):
		case (reOrgNotificationConstants.Create.REQUEST):
		case (reOrgNotificationConstants.Read.REQUEST):
		case (reOrgNotificationConstants.DownloadFile.REQUEST):
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case (reOrgNotificationConstants.GetPaged.FAILURE):
		case (reOrgNotificationConstants.GetPagedAll.FAILURE):
		case (reOrgNotificationConstants.Create.FAILURE):
		case (reOrgNotificationConstants.Read.FAILURE):
		case (reOrgNotificationConstants.DownloadFile.FAILURE):
			return {
				...state,
				isSending : false,
				error     : action.payload
			}
		case (reOrgNotificationConstants.GetPaged.SUCCESS):
		case (reOrgNotificationConstants.GetPagedAll.SUCCESS):
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case (reOrgNotificationConstants.GetAny.SUCCESS):
			return {
				...state,
				isAny: action.payload.result
			}
		case (reOrgNotificationConstants.Create.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : 'Уведомление успешно отправлено.'
			}
		case (reOrgNotificationConstants.Read.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : 'Уведомление прочитано.'
			}
		case (reOrgNotificationConstants.DownloadFile.SUCCESS):
			return {
				...state,
				isSending: false
			}
		case (reOrgNotificationConstants.CLEAR):
			return {
				...state,
				error     : null,
				isSending : false,
				changed   : null,
				paged     : {}
			}
		default:
			return state
	}
}